Ext.define('SA.Viewport', {
    singleton: true,

    mixins: {
        observable: 'Ext.util.Observable'
    },

    initialize() {
        Ext.fly(document.documentElement).addCls('x-viewport');

        this.mixins.observable.constructor.call(this);

        Ext.EventManager.onWindowResize(this.onResize, this);
    },

    onResize() {
        Ext.getScrollbarSize(true);

        this.fireEvent('resize', this);
    }
});
